import { BrightcoveVideo } from "@components/Brightcove/utils/types";
import Card from "@particles/card/Card";
import { CardImage, CardVariations } from "@particles/card/utils/types";
import { cn, textToSlug } from "@util/helpers";

export type VideosStoriesProps = BrightcoveVideo & {
  index: number;
};

export default function VideosStories({
  id,
  name,
  images,
  index,
}: VideosStoriesProps): React.ReactElement {
  const isLeadArticle = index === 0;
  const thumbnail: CardImage = {
    src: images.thumbnail.src,
    alt: name,
    width: images.thumbnail.sources[0].width,
    height: images.thumbnail.sources[0].height,
  };

  const variant: CardVariations = {
    image: {
      position: "",
      width: "!w-120px lg:!w-full",
      isVideo: true,
      extraClass: "h-fit",
      aspectRatio: "aspect-video",
    },
    content: {
      width: "w-full-120px lg:w-full",
      extraClass: cn({
        "pl-4 lg:pl-0 lg:pt-4": isLeadArticle,
      }),
    },
    title: {
      color: "!text-gray-850",
      size: isLeadArticle ? "text-lg" : "text-base",
      extraClass: "font-lct",
    },
  };

  return (
    <div
      className={cn("video border-b border-gray-175 py-3", {
        "border-none": index === 2,
      })}
    >
      <Card
        id={id}
        link={`/videos/${textToSlug(name)}/${id}`}
        title={name}
        variations={variant}
        thumbnail={isLeadArticle ? thumbnail : undefined}
      />
    </div>
  );
}
